export default {
  "content": "<path d=\"M5 7.333A2.333 2.333 0 017.333 5h9.334A2.333 2.333 0 0119 7.333v9.334A2.333 2.333 0 0116.667 19H7.333A2.333 2.333 0 015 16.667V7.333z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};